import React, {useCallback, useState} from 'react';
import {useIntl} from 'react-intl';
import {SubSection} from '../../../project-tab/projects/project-settings/ProjectSettings_styled';
import InlineLoader from '../../../shared/components/inline-loader/inline_loader';
import GenericIntegrationLinkedFields from './GenericIntegrationLinkedFields';
import HubspotSyncDirectionSettings from './HubspotSyncDirectionSettings';

const HubspotLinkedFieldsAndSyncDirection = ({syncDirectionEnabled}) => {
	const intl = useIntl();
	const [linkedFields, setLinkedFields] = useState(null);

	const onHubspotLinkedFieldsUpdated = useCallback(fields => {
		setLinkedFields(fields);
	}, []);

	if (!syncDirectionEnabled) {
		return (
			<SubSection
				title={intl.formatMessage({id: 'settings.app_catalog.hubspot.linked_fields_title'})}
				description={intl.formatMessage({id: 'settings.app_catalog.hubspot.linked_fields_description'})}
			>
				<GenericIntegrationLinkedFields integrationName="hubspot" />
			</SubSection>
		);
	}

	return (
		<>
			<SubSection
				title={intl.formatMessage({id: 'settings.app_catalog.hubspot.linked_fields_title'})}
				description={intl.formatMessage({id: 'settings.app_catalog.hubspot.linked_fields_description'})}
			>
				<GenericIntegrationLinkedFields
					integrationName="hubspot"
					onHubspotLinkedFieldsUpdated={onHubspotLinkedFieldsUpdated}
				/>
			</SubSection>
			<SubSection
				title={intl.formatMessage({id: 'settings.app_catalog.hubspot.sync_direction_title'})}
				description={intl.formatMessage({id: 'settings.app_catalog.hubspot.sync_direction_description'})}
			>
				{linkedFields ? <HubspotSyncDirectionSettings linkedFields={linkedFields} /> : <InlineLoader />}
			</SubSection>
		</>
	);
};

export default HubspotLinkedFieldsAndSyncDirection;
